// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"576":"3a7aeb0e","631":"5d7e45f7","670":"6b3bd75e"}[chunkId] + ".chunk.js";
};